<ph-stack gap="tight">
    <ph-button *ngIf="staysInDrawer; else budgetLink" variant="secondary" mode="filled" size="small" type="button"
       trailing-icon="arrow-up-right"
       [routerLink]="urlPath"
       [queryParams]="urlQueryParams">
        {{ label }}
    </ph-button>
    <ng-template #budgetLink>
        <ph-link-button
           variant="primary"
           trailing-icon="arrow-right"
           [routerLink]="urlPath"
           [queryParams]="urlQueryParams"
           (click)="onNavigate()">
            {{ label }}
        </ph-link-button>
    </ng-template>
    <ph-hint *ngIf="helperText">{{ helperText }}</ph-hint>
</ph-stack>
